import React from 'react';

const pct = (value, start, end) => (end > start ? Math.max(0, Math.min(100, ((value - start) / (end - start)) * 100)) : 0);
const clockText = ms => new Date(ms).toLocaleTimeString('fr-FR');
/** Un segment HLS dure ≈ 6 s : la fin d'un enregistrement est l'arrivée de son dernier segment, plus un segment. */
const SEGMENT_MS = 6000;

/**
 * Sous la timeline commune, une ligne par personne : où sont ses vidéos (plein),
 * ses enregistrements de son (hachuré) et ses photos (traits blancs). Un clic
 * sur une ligne place le curseur à cet instant.
 */
export default function RendezVousMediaLanes({ tracks, start, end, t, onSeek, alerts = null }) {
    if (!tracks?.length || !(end > start)) return null;
    const at = event => {
        const rect = event.currentTarget.parentElement.getBoundingClientRect();
        return start + ((event.clientX - rect.left) / rect.width) * (end - start);
    };
    const seekAt = event => {
        const rect = event.currentTarget.getBoundingClientRect();
        onSeek(start + ((event.clientX - rect.left) / rect.width) * (end - start));
    };
    return (
        <div className="rid-lanes" aria-label="Captures sur la timeline">
            {alerts?.length > 0 && (
                <div className="rid-lane">
                    <span className="rid-lane-label" style={{ color: '#EF4444' }}>🚨 Alerte</span>
                    <div className="rid-lane-bar" onClick={seekAt} role="presentation">
                        {alerts.map(alert => {
                            const left = pct(alert.startMs, start, end);
                            const right = pct(alert.endMs || end, start, end);
                            return (
                                <span
                                    key={alert.id}
                                    className="rid-lane-media rid-lane-alert"
                                    style={{ left: `${left}%`, width: `${Math.max(0.8, right - left)}%`, background: '#EF4444', borderColor: '#EF4444', cursor: 'pointer' }}
                                    title={`${alert.label} : ${clockText(alert.startMs)} → ${alert.endMs ? clockText(alert.endMs) : 'en cours'}`}
                                    onClick={event => { event.stopPropagation(); onSeek(Math.max(alert.startMs, at(event))); }}
                                />
                            );
                        })}
                        <span className="rid-lane-cursor" style={{ left: `${pct(t, start, end)}%` }} />
                    </div>
                </div>
            )}
            {tracks.filter(track => track.kind !== 'responder').map(track => (
                <div key={track.id} className="rid-lane">
                    <span className="rid-lane-label" style={{ color: track.color }} title={track.email || track.label}>{track.label}</span>
                    <div className="rid-lane-bar" onClick={seekAt} role="presentation">
                        {(track.media || []).map(media => {
                            const left = pct(media.startMs, start, end);
                            const stop = (media.endMs || media.startMs) + (media.exactRange ? 0 : SEGMENT_MS);
                            const right = pct(stop, start, end);
                            return (
                                <span
                                    key={media.id}
                                    className={`rid-lane-media rid-lane-${media.type}`}
                                    style={{ left: `${left}%`, width: `${Math.max(0.6, right - left)}%`, background: media.type === 'video' ? track.color : undefined, borderColor: track.color }}
                                    title={`${media.label} : ${clockText(media.startMs)} → ${clockText(stop)}`}
                                />
                            );
                        })}
                        {(track.photos || []).map(photo => (
                            <span
                                key={photo.id}
                                className={`rid-lane-photo ${photo.purpose === 'arrival' ? 'rid-lane-arrival' : ''}`}
                                style={{ left: `${pct(photo.t, start, end)}%` }}
                                title={`${photo.purpose === 'arrival' ? 'Photo d’arrivée' : 'Photo'} · ${clockText(photo.t)}`}
                            />
                        ))}
                        <span className="rid-lane-cursor" style={{ left: `${pct(t, start, end)}%` }} />
                    </div>
                </div>
            ))}
            <div className="rid-lane-legend">
                {alerts?.length > 0 && <span><i style={{ background: '#EF4444' }} /> Alerte</span>}
                <span><i className="rid-legend-video" /> Vidéo</span>
                <span><i className="rid-legend-audio" /> Son</span>
                <span><i className="rid-legend-arrival" /> Photo d’arrivée</span>
                <span><i className="rid-legend-photo" /> Photo</span>
            </div>
        </div>
    );
}
